import { render, staticRenderFns } from "./VerTodosSignosVitales.vue?vue&type=template&id=5820ec5b&scoped=true"
import script from "./VerTodosSignosVitales.vue?vue&type=script&lang=js"
export * from "./VerTodosSignosVitales.vue?vue&type=script&lang=js"
import style0 from "./VerTodosSignosVitales.vue?vue&type=style&index=0&id=5820ec5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820ec5b",
  null
  
)

export default component.exports